import React, {useCallback, useMemo, useState} from "react"
import {Box} from "@mui/system"
import {Grid, Typography} from "@mui/material"

import ButtonWithIcon from "src/v2/components/Button/Button"
import {ReactComponent as ChatIcon} from "src/v2/assets/icons/chat-icon.svg"
import PropTypes from "prop-types"
import theme from "../../theme/theme"

import ChatbotInModal from "../Chatbot/chatbot-modal"

const Header = ({
    title,
    hideHelpButton,
    imageBackground,
    backgroundPosition,
    actionButton,
    variant = "v1" 
}) => {

    const isV1 = variant === "v1"

    const [isChatOpen, setIsChatOpen] = useState(false)

    const handleClickHelpButton = useCallback(() => {
        setIsChatOpen(true)
    }, [])

    const handleCloseChat = useCallback(() => {
        setIsChatOpen(false)
    }, [])

    const chatIcon = useMemo(() => <ChatIcon/>, [])

    return (
        <Grid
            sx={{
                background: theme.palette.background.primary,
                height: "100%",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: {
                        xxxs: 0,
                        lg: 209,
                    },
                    right: 0,
                    zIndex: 0,
                }}
            >
                <Box>
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            height: {xxxs: "2100px", md: "210px"},
                            mt: {xxxs: 8, lg: 0},
                            width: "100%",
                            zIndex: 0,
                            overflow: "hidden",
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                inset: 0,
                                backgroundImage: `
                                  linear-gradient(to right, rgba(0,0,0,0.8) 20%, rgba(0,0,0,0) 40%),
                                  url(${imageBackground || "/background/background-sistemas.webp"})
                                `,
                                backgroundSize: "130% auto",
                                backgroundPosition: backgroundPosition || "0% 77%",
                                backgroundRepeat: "no-repeat",
                                filter: "grayscale(80%)",
                                zIndex: -1
                            }
                        }}
                    >

                        {/* 🔹 V1 */}
                        {isV1 && (
                            <>
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    width="100%"
                                    height="100%"
                                    gap={3}
                                    mt={3}
                                    px={3}
                                    pt={1}
                                >
                                    <Box display="flex" width="100%" justifyContent="flex-end">
                                        {!hideHelpButton && (
                                            <ButtonWithIcon
                                                size="md"
                                                icon={chatIcon}
                                                onClick={handleClickHelpButton}
                                            >
                                                AJUDA
                                            </ButtonWithIcon>
                                        )}
                                    </Box>
                                </Box>

                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    width="100%"
                                    mt={3}
                                    px={3}
                                    pt={1}
                                    pb={4}
                                >
                                    <Typography variant="h2" color="common.white">
                                        {title}
                                    </Typography>

                                    {actionButton && (
                                        <ButtonWithIcon
                                            size="md"
                                            icon={actionButton.icon}
                                            onClick={actionButton.onClick}
                                        >
                                            {actionButton.label}
                                        </ButtonWithIcon>
                                    )}
                                </Box>
                            </>
                        )}

                        {/* 🔹 V2 */}
                        {!isV1 && (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                                px={3}
                                pt={2}
                                pb={120}
                            >
                                <Typography variant="h2" color="common.white">
                                    {title}
                                </Typography>

                                <Box display="flex" gap={2}>
                                    {!hideHelpButton && (
                                        <ButtonWithIcon
                                            size="md"
                                            icon={chatIcon}
                                            onClick={handleClickHelpButton}
                                        >
                                            AJUDA
                                        </ButtonWithIcon>
                                    )}

                                    {actionButton && (
                                        <ButtonWithIcon
                                            size="md"
                                            icon={actionButton.icon}
                                            onClick={actionButton.onClick}
                                        >
                                            {actionButton.label}
                                        </ButtonWithIcon>
                                    )}
                                </Box>
                            </Box>
                        )}

                    </Box>
                </Box>
            </Box>

            <ChatbotInModal
                open={isChatOpen}
                onClose={handleCloseChat}
            />
        </Grid>
    )
}

Header.propTypes = {
    callBackOnChange: PropTypes.func,
    title: PropTypes.string,
    hideHelpButton: PropTypes.bool,
    imageBackground: PropTypes.string,
    backgroundPosition: PropTypes.string,
    actionButton: PropTypes.node,
    variant: PropTypes.oneOf(["v1", "v2"]) 
}

Header.defaultProps = {
    variant: "v1"
}

export default Header